<script>
    import { onMount } from "svelte";
    import Modal from "sv-bootstrap-modal";
    import UserProducstApi from "../api/user_products";
    import UserApi from "../api/user";
    import Util from "../util";
    import Pagination from "./Pagination.svelte";
    import Tooltip from "./Tooltip.svelte";
    import AutoSavingLoading from "./AutoSavingLoading.svelte";

    let itemSelected = {};
    let isOpen = false;
    let items = [];
    let newProductName;
    let newProductInputs = [, , , ,];
    let newProduct = false;
    let userProfile = {};
    let saving = false;
    const savingTimeout = 1000;
    //
    const addProduct = async () => {
        if (!newProductInputs.length) return;
        try {
            saving = true;
            Util.showProgress();
            await UserProducstApi.postAsync({
                name: newProductInputs[0],
                measurementL: newProductInputs[1],
                measurementA: newProductInputs[2],
                measurementB: newProductInputs[3],
            });
            newProduct = false;
            newProductInputs = [, , , ,];
            await loadProducts();
        } catch (error) {
            newProduct = false;
            newProductInputs = [, , , ,];
            //
        } finally {
            Util.hideProgress();
            setTimeout(() => saving = false, savingTimeout);
        }
    };
    const loadProducts = async () => {
        try {
            items = await UserProducstApi.getAsync();
            if (productCurrentPag == 0) productCurrentPag = 1;
        } catch (error) {
            console.error(error);
        }
    };
    const loadUserProfile = async () => {
        try {
            userProfile = await UserApi.getAsync();
        } catch (error) {
            console.error(error);
        }
    };
    // Lifecycle
    onMount(async () => {
        await loadProducts();
        await loadUserProfile();
        Util.popoverInit();
    });
    // Events
    const onDelete = (item) => {
        itemSelected = item;
        isOpen = true;
    };
    const onDeleteOk = async () => {
        try {
            saving = true;
            Util.showProgress();
            await UserProducstApi.deleteAsync({ productId: itemSelected.ID });
            await loadProducts();
            isOpen = false;
        } catch (error) {
            console.error(error);
        } finally {
            Util.hideProgress();
            setTimeout(() => saving = false, savingTimeout);
        }
    };
    const onRetrieveData = () => {
        ColorCalcRetrieveData.show();
    };
    const onSaveProduct = async (product) => {
        try {
            saving = true;
            Util.showProgress();
            await UserProducstApi.patchAsync({
                productId: product.ID
            },
            {
                name: product.Name,
                measurementL: product.MeasurementL,
                measurementA: product.MeasurementA,
                measurementB: product.MeasurementB,
            });
            await loadProducts();
        } catch (error) {
            newProduct = false;
            newProductInputs = [, , , ,];
            //
        } finally {
            Util.hideProgress();
            setTimeout(() => saving = false, savingTimeout);
        }
    };
    const onSaveEmail = () => {
        ColorCalcAnonymousData.show();
    };
    //
    $: if (newProductName) newProductName.focus();
    //
    // Pagination
    let productPag = [],
        productCurrentPag = 0,
        productTotalPag = 0,
        productTotalItems = 0,
        productItemsPerPag = 10,
        productItemPagFm = 0,
        productItemPagTo = 0;

    $: if (productCurrentPag > 0) {
        productTotalItems = items.length;
        productTotalPag = Math.ceil(productTotalItems / productItemsPerPag);
        productItemPagFm = productCurrentPag * productItemsPerPag - productItemsPerPag;
        productItemPagTo = productCurrentPag * productItemsPerPag;
        productPag = items.slice(productItemPagFm, productItemPagTo);
    }
</script>

<Tooltip style="top: 20px; left: 0px; display: none;" position="top" number="1" title="" text="List of your current product configurations that are sent from the ‘Construct IGUs’ page.  IGDB color values (L*, a*, b*) for the configurations are sent as well.  One or all the product configurations can then be selected to be assigned to individual Projects.  Custom Product Configurations can also be entered without using the Construct IGUs page" />
<Tooltip style="top: 230px; left: 150px; display: none;" position="bottom" number="2" title=""  text="Here are listed your various saved Projects and associated Product Configurations and Color Data.  If you have not created a Project yet, use the ‘+Create New Project’ button, and you will be able to name the project and select product configurations to add to it." />
<div class="mt-1">
    <AutoSavingLoading saving={saving} />
</div>
<div class="mt-1" style="display: flex;justify-content: flex-end;font-size: 10px;">
    <span>*All changes are autosaved</span>
</div>
<div class="row mb-3">
    <div class="col-12 sm-6 ml-3">
        <div style="display: flex; align-items: center;">
            <a href="#/products" type="button" class="btn btn-orange active text-white"
                title="List of your current product configurations">
                Configuration/Products</a>
            <a href="#/projects" type="button" class="btn btn-gray text-secondary"
                title="List of your current projects">
                Projects
            </a>
            {#if !userProfile.Email}
                <a href="!" on:click|preventDefault={onRetrieveData} type="button"
                    class="btn btn-gray text-secondary optional-action"
                    title="Retrieve your previous data saved by input your email">
                    Retrieve Data
                </a>
                <a href="!" on:click|preventDefault={onSaveEmail} type="button"
                    class="btn btn-gray text-secondary optional-action"
                    title="Associate an email to your current progress and retrieve it later by using 'Retrieve Data'">
                    Save Progress
                </a>
            {/if}
            {#if userProfile.Email}
                {#if !userProfile.Origin}
                    <div style="flex: 1; padding: 0px 10px; display: flex; justify-content: flex-end;">
                        <span style="display: {userProfile.Origin ? 'none' : 'block'};">
                            Your email is: <strong>{userProfile.Email || ''}</strong>
                        </span>
                    </div>
                {:else}
                    <div style="flex: 1; padding: 0px 10px; display: flex; justify-content: flex-end;">
                        <span>Saved email: <strong>{userProfile.Email}</strong></span>
                    </div>
                {/if}
            {/if}
        </div>
    </div>
</div>
{#if items.length}
    <div class="mb-3">
        <p>
            Visit
            <a href="!" on:click|preventDefault={Util.navigateToRoot}>Construct IGU’s</a>
            to add products to start a configuration
        </p>
    </div>
{/if}
<div class="row">
    <div class="col-12 ml-3">
        <table class="table table-bordered" style="table-layout: fixed">
            <thead class="thead tbl-gray text-white">
                <tr>
                    <td style="width: 400px;">Product</td>
                    <td>L°</td>
                    <td>a°</td>
                    <td>b°</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                {#each productPag as product}
                    {#if product.isEditing}
                        <tr class="new-edit-product">
                            <td>
                                <div class="flex">
                                    <input bind:this={newProductName} bind:value={product.edit.Name} type="text" maxlength="1000" />
                                </div>
                            </td>
                            <td>
                                <div class="flex">
                                    <input class="measurement" type="number" bind:value={product.edit.MeasurementL} />
                                </div>
                            </td>
                            <td>
                                <div class="flex">
                                    <input class="measurement" type="number" bind:value={product.edit.MeasurementA} />
                                </div>
                            </td>
                            <td>
                                <div class="flex">
                                    <input class="measurement" type="number" bind:value={product.edit.MeasurementB} />
                                </div>
                            </td>
                            <td>
                                <div class="flex-center">
                                    <i on:click={() => onSaveProduct(product.edit)}
                                        title="Save changes"
                                        class="btn-action pe-3 bi bi-save text-primary fs-5" />
                                    <i on:click={() => {
                                        delete product.edit;
                                        product.isEditing = false;
                                    }}
                                        title="Cancel changes"
                                        class="btn-action bi bi-x-lg text-danger fs-5" />
                                </div>
                            </td>
                        </tr>
                    {:else}
                        <tr>
                            <td>{product.Name}</td>
                            <td>{product.MeasurementL}</td>
                            <td>{product.MeasurementA}</td>
                            <td>{product.MeasurementB}</td>
                            <td class="flex-center">
                                {#if product.Editable}
                                    <i on:click={() => {
                                        product.edit = Object.assign({}, product);
                                        product.isEditing = true;
                                    }}
                                        title="Edit custom configuration"
                                        class="btn-action pe-3 bi bi-pencil-square text-primary fs-5" />
                                {/if}
                                <i on:click={() => onDelete(product)}
                                    title="Delete product configuration"
                                    class="btn-action bi bi-trash text-danger fs-5" />
                            </td>
                        </tr>
                    {/if}
                {:else}
                    <tr>
                        <td colspan="5">
                            <p>
                                The are no products added to the configuration. Visit
                                <a href="!" on:click|preventDefault={Util.navigateToRoot}>Construct IGU’s</a>
                                to add products to start a configuration
                            </p>
                        </td>
                    </tr>
                {/each}
                {#if newProduct}
                    <tr class="new-edit-product">
                        {#each newProductInputs as entry, i}
                            {#if i == 0}
                                <td>
                                    <div class="flex">
                                        <input bind:this={newProductName} bind:value={entry} type="text" maxlength="1000" />
                                    </div>
                                </td>
                            {:else}
                                <td>
                                    <div class="flex">
                                        <input class="measurement" type="number" bind:value={entry} />
                                    </div>
                                </td>
                            {/if}
                        {/each}
                        <td>
                            <div class="flex-center">
                                <i on:click={addProduct}
                                    class="btn-action pe-3  bi bi-save text-primary fs-5"
                                    title="Create custom configuration" />
                                <i on:click={() => newProduct = false}
                                    class="btn-action bi bi-x-lg text-danger fs-5"
                                    title="Cancel" />
                            </div>
                        </td>
                    </tr>
                {/if}
            </tbody>
        </table>
        {#if productTotalItems > productItemsPerPag}
            <Pagination bind:current_page={productCurrentPag} last_page={productTotalPag} per_page={productItemsPerPag} from={productItemPagFm} to={productItemPagTo} total={productTotalItems} />
        {/if}
    </div>
</div>
<div class="row">
    <div class="col-12 ml-3">
        {#if !newProduct}
            <button on:click={() => (newProduct = true)} type="button"
                class="btn  btn-outline-blue btn-sm "
                title="Add a custom product configuration without usgin the Construct IGUs">
                <i class="bi bi-plus-lg" />
                <span>New Product</span>
            </button>
        {/if}
    </div>
</div>
<Modal bind:open={isOpen} class="modal-dialog">
    <div class="modal-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 text-end">
                    <button type="button" class="btn-close" on:click={() => (isOpen = false)} aria-label="Close" />
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <p class="fw-bold fs-6">Confirm operation</p>
                    <br />
                    <p>Are you sure you want to delete?</p>
                    <br />
                    <p>{itemSelected.Name}</p>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-end">
                    <button type="button" on:click={() => (isOpen = false)}
                        class="btn btn-outline-blue mr-3"
                        title="Cancel operation">
                        Cancel
                    </button>
                    <button type="button" on:click={() => onDeleteOk()}
                        class="btn btn-outline-danger mr-3"
                        title="Delete product configuration from your list">
                        Delete
                    </button>
                </div>
            </div>
        </div>
    </div>
</Modal>

<style>
    a:hover {
        text-decoration: none;
        color: #009ddb;
    }

    .btn-action:hover {
        cursor: pointer;
    }

    .btn-orange {
        background-color: #e67e22;
    }

    .btn-gray {
        background-color: #e5e7e9;
    }

    .btn-outline-blue {
        border: 2px solid black;
        background-color: white;
        border-color: #3cb1d6;
        color: #3cb1d6;
    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .optional-action {
        margin-left: 10px;
    }

    .flex {
        display: flex;
    }

    .new-edit-product .flex input {
        flex: 1;
        padding: 5px;
    }

    .measurement {
        width: 100px;
    }

    .tbl-gray {
        background-color: #3d4952;
    }
</style>
